<style lang="less" scoped>
  .recipe-type-btn {
    color: #7ed321;
    border: 1px solid #7ed321;
    position: relative;
    .recipe-type-btn-icon {
      width: 24px;
      position: absolute;
      left: 10px;
      top: 7px;
    }
  }
  .recipe-type-dialog-close-btn {
    color: #7ed321;
    border: none;
  }
</style>

<template lang="pug">
  .recipe-type-cover.dialog-content-cover
    .dialog-content-row
      el-button.recipe-type-btn.w10(
        type="default",
        @click="openDialog(2)")
        img.recipe-type-btn-icon(src="@/assets/prescription@2x.png")
        span 처방전 선택
    .dialog-content-row
      el-button.recipe-type-btn.w10(
        type="default"
        @click="openDialog(1)")
        img.recipe-type-btn-icon(src="@/assets/pencil@2x.png")
        span 직접 처방
    .dialog-content-row(@click="closeDialog()")
      el-button.w10.recipe-type-dialog-close-btn(type="default") 취소
</template>

<script>
export default {
  methods: {
    closeDialog() {
      this.$emit('closeDialog');
    },
    openDialog(dialog) {
      this.$emit('openDialog', dialog);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/modal/modal_recipe_add.vue